import { getLimit } from './auth';
import { getOwnsAnyPaidParcel } from './scopeUtils';
const MAX_USERS_TO_RING_PER_WORKSPACE_DEFAULT = 100;
export const hasCallingMinutesPerPortal = () => {
  if (!getOwnsAnyPaidParcel()) {
    return false;
  }
  const callingMinutesPerPortal = getLimit('calling-minutes-per-portal');
  return callingMinutesPerPortal ? callingMinutesPerPortal > 0 : false;
};
export const getMaximumCallingChannelsPerPortal = () => {
  return getLimit('calling-maximum-calling-channels-per-portal');
};
export const getMaximumUsersToRingPerWorkspace = () => {
  return getLimit('calling-maximum-users-to-ring-per-workspace-calling-channel') || MAX_USERS_TO_RING_PER_WORKSPACE_DEFAULT;
};